var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getClosedServiceEntries from '../../requests/service/getClosedServiceEntries';
/**
 *
 */
var GetClosedServiceEntriesCommand = /** @class */ (function (_super) {
    __extends(GetClosedServiceEntriesCommand, _super);
    function GetClosedServiceEntriesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param closedServiceEntriesCollection ServiceEntriesCollection
     * @param requestedPage Number
     * @param numberOfItemsPerPage Number
     * @return {*}
     */
    GetClosedServiceEntriesCommand.prototype.execute = function (organisation, closedServiceEntriesCollection, requestedPage, numberOfItemsPerPage) {
        if (requestedPage === void 0) { requestedPage = 1; }
        if (numberOfItemsPerPage === void 0) { numberOfItemsPerPage = 10; }
        this.closedServiceEntriesCollection = closedServiceEntriesCollection;
        var promise = getClosedServiceEntries(organisation, requestedPage, numberOfItemsPerPage);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    GetClosedServiceEntriesCommand.prototype.then = function (response) {
        this.closedServiceEntriesCollection.reset();
        this.closedServiceEntriesCollection.addAll(response.closedServiceEntries);
    };
    return GetClosedServiceEntriesCommand;
}(Command));
export default GetClosedServiceEntriesCommand;
